import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'all_matches';

export const useAllMatchesTranslation = (): UseTranslationResponse<'widgets', typeof keyPrefix> => {
  return useTranslation('widgets', { keyPrefix });
};

export const ruRu = ({
  [keyPrefix]: {
    title: 'Все совпадения',
    show_more: 'Показать еще',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    title: 'All matches',
    show_more: 'Show more',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    title: 'Todas las coincidencias',
    show_more: 'Mostrar más',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    title: 'Todas as correspondências',
    show_more: 'Mostrar mais',
  },
}) as Record<string, unknown>;
